let ReactFontawesome: any = {};
try {
  ReactFontawesome = require('@fortawesome/react-fontawesome');
} catch (err) {}

export default ReactFontawesome;
